import { h } from 'preact';

const FitText = ({ product }) => {
  const fitTextValue = product?.fitText?.value || product.fitText;

  if (!fitTextValue) {
    return null;
  }

  return (
    <div className="body-3 text-text-subdued opacity-80 text-left">
      {fitTextValue}
    </div>
  );
};

export default FitText;
